import { MESSAGE_PRIORITY_TYPES, MESSAGE_STATUSES, MESSAGE_TYPES } from "@/types/constants/common";
import { TripMessageObj } from "@/types/interfaces/crm";
import { getTripMessagePriorityChip, getTripMessageStatusChip } from "@/utils/trip";
import ModalDialog from "@mui/joy/ModalDialog";
import Modal from "@mui/joy/Modal";
import DialogTitle from "@mui/joy/DialogTitle";
import ModalClose from "@mui/joy/ModalClose";
import Stack from "@mui/joy/Stack";
import Typography from "@mui/joy/Typography";
import { ColDef, ICellRendererParams, ValueGetterParams } from "ag-grid-community";
import { format } from "date-fns";
import { useState } from "react";
import { parseDate } from "@/components/ItineraryBuilder/utils";

const messagesColumns: ColDef[] = [
  {
    field: "subject",
    headerName: "Subject",
    minWidth: 50,
    flex: 3,
    cellRenderer: ({ value, data }: ICellRendererParams<TripMessageObj>) => {
      const [showModal, setShowModal] = useState(false);

      return (
        <>
          <Modal open={showModal} onClose={() => setShowModal(false)}>
            <ModalDialog
              sx={{
                minWidth: "500px",
              }}
            >
              <ModalClose />
              <DialogTitle
                sx={{
                  mb: 2,
                }}
              >
                Message
              </DialogTitle>{" "}
              <Stack
                sx={{
                  overflowY: "auto",
                  overflowX: "hidden",
                }}
              >
                <Typography>
                  <Typography fontWeight={"lg"}>Subject: </Typography>
                  {value}
                </Typography>
                <p
                  dangerouslySetInnerHTML={{
                    __html: data?.message || "",
                  }}
                />
              </Stack>
            </ModalDialog>
          </Modal>
          <Typography
            color="primary"
            sx={{
              cursor: "pointer",
            }}
            onClick={() => setShowModal(true)}
          >
            {value || "No Subject"}
          </Typography>
        </>
      );
    },
  },
  {
    colId: "status",
    headerName: "Status",
    flex: 1,
    valueGetter: ({ data }: ValueGetterParams<TripMessageObj>) =>
      (data?.status || data?.status === 0) && (MESSAGE_STATUSES as any)[data.status]?.name
        ? (MESSAGE_STATUSES as any)[data.status]?.name
        : "_",
    cellRenderer: ({ data }: ICellRendererParams<TripMessageObj>) =>
      data?.status || data?.status === 0 ? getTripMessageStatusChip(data.status) : "_",
  },
  {
    colId: "Priority",
    headerName: "Priority",
    flex: 1,
    valueGetter: ({ data }: ValueGetterParams<TripMessageObj>) =>
      (data?.priority || data?.priority === 0) && (MESSAGE_PRIORITY_TYPES as any)[data.priority]?.name
        ? (MESSAGE_PRIORITY_TYPES as any)[data.priority]?.name
        : "_",
    cellRenderer: ({ data }: ICellRendererParams<TripMessageObj>) =>
      data?.priority || data?.priority === 0 ? getTripMessagePriorityChip(data.priority) : "_",
  },
  {
    colId: "MessageType",
    headerName: "Type",
    flex: 1,
    valueGetter: ({ data }: ValueGetterParams<TripMessageObj>) =>
      data?.messageType ? (MESSAGE_TYPES as any)[data.messageType] || "_" : "_",
  },
  {
    colId: "messageDate",
    headerName: "Message Date",
    flex: 1,
    valueGetter: ({ data }) =>
      data?.messageDate ? format(parseDate(data?.messageDate.split("T")[0]), "MMM dd, yyyy") : "_",
  },
];

export default messagesColumns;
